import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc} from "firebase/firestore"

const getAllPessoas = async ()=>{
  const pessoasRef = collection(db, "pessoas");
  const params = []
  const pessoasList = []
  // params.push(where("active", "!=", false))
  let q = null
  q = query(pessoasRef, ...params);
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    pessoasList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return pessoasList.filter((item)=> {
    if(item.hasOwnProperty('active')){
      return item.active;
    }else{
      return true;
    }
  })
}

const savePessoa = async (payload) => {
  const colRef = collection(db, 'pessoas')
  await addDoc(colRef, payload)
}

const deletePessoa = async (payload) => {
  const colRef = await doc(db, 'pessoas', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const updatePessoa = async (payload) => {
  const colRef = await doc(db, "pessoas", payload.id);
  await updateDoc(colRef, payload);
}

export { getAllPessoas, savePessoa, updatePessoa, deletePessoa }
